const DEFAULT_BACK_URL = 'https://smbpaasadmin.lenovo.com'

type LenovoBackOptions = {
  backUrl?: string
}

function navigateToTopLevel(backUrl: string) {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = backUrl
      return
    }
  } catch (error) {
    console.warn('top-level navigation failed, fallback to current window', error)
  }

  window.location.href = backUrl
}

export function triggerLenovoBack(options: LenovoBackOptions = {}) {
  localStorage.removeItem('lenovo-token')
  localStorage.removeItem('ws_token')
  localStorage.removeItem('isLogin')

  const backUrl = options.backUrl || localStorage.getItem('lenovo-back-url') || DEFAULT_BACK_URL
  const isMicroApp = Boolean((window as any).__MICRO_APP_ENVIRONMENT__)
  const microAppEventCenter = (window as any).microApp
  const dispatch = microAppEventCenter?.forceDispatch || microAppEventCenter?.dispatch

  if (isMicroApp && dispatch) {
    dispatch.call(microAppEventCenter, {
      type: 'logout',
      payload: {
        backUrl,
      },
    })

    // 宿主未接管或接管延迟时，强制提升到顶层窗口跳转，避免在 iframe 内加载外部登录页。
    window.setTimeout(() => {
      navigateToTopLevel(backUrl)
    }, 80)

    return
  }

  navigateToTopLevel(backUrl)
}